/**
 * Роли и причины, по которым диспетчер не берёт работу.
 *
 * Здесь только перечисления домена. Поля сущностей описаны один раз —
 * в схеме базы (@cc/db) и в контрактах (../api/*.dto.ts); дублировать
 * их интерфейсами нельзя, копии разъезжаются на первой правке.
 */
/** Роли. Права проверяются на сервере в каждом маршруте, роль берётся из сессии */
export const ROLES = ['admin', 'supervisor', 'dispatcher'];
/**
 * Почему диспетчер сейчас не получает контакты (§6.2).
 * Показывается админу как есть: «почему не раздаётся» — первый вопрос при разборе.
 */
export const BLOCKED_REASONS = [
    /** Вне графика смены */
    'off_shift',
    /** Не нажал «готов» в пульте */
    'not_ready',
    /** Софтфон не зарегистрирован на станции */
    'no_sip',
    /** Пульт не на связи */
    'no_ws',
    /** Выбран дневной лимит контактов */
    'daily_limit',
    /** Уже держит максимум незакрытых карточек */
    'max_open',
];
//# sourceMappingURL=user.js.map